function breedAndTypeMetadata(searchParams: { [key: string]: string | undefined }) {
  const animalType = (searchParams['animal-type'] as 'all' | 'dog' | 'cat') ?? 'all';
  const breed = searchParams.breeds ?? '';
  const publicationType = searchParams['publication-type'] as
    | 'all'
    | 'продажа'
    | 'дарение'
    | 'случка'
    | undefined;

  const actionTextMap = {
    all: 'Купить',
    продажа: 'Купить',
    дарение: 'В дар',
    случка: 'Вязка, случка'
  };

  const descriptionTextMap = {
    продажа: 'по продаже',
    дарение: 'по дарению',
    случка: 'по случке и вязке',
    all: 'по покупке'
  };

  const actionText = actionTextMap[publicationType || 'all'];
  const descriptionActionText = descriptionTextMap[publicationType || 'all'];
  const isCat = animalType === 'cat';
  const breedText = breed ? `породы ${breed}` : 'разной породы';

  let animalText;
  if (actionText === 'Вязка, случка') {
    animalText = isCat ? 'котов и кошек' : 'кобелей и сук';
  } else {
    animalText = isCat ? 'котят' : 'щенков';
  }

  if (animalType === 'all') {
    return {
      title: `${actionText} котенка или щенка - Найдите идеального питомца`,
      description: `Ищете котёнка или щенка породы определенной породы? Ознакомьтесь с нашими предложениями ${descriptionActionText} породистых котят и щенков. Мы предлагаем здоровых и привитых котят и щенков от проверенных заводчиков. Найдите идеального четвероногого друга для вашей семьи уже сегодня!`
    };
  } else {
    return {
      title: `${actionText} ${animalText} ${breedText} - Найдите идеального питомца`,
      description: `Ищете ${animalText} ${breedText}? Ознакомьтесь с нашими предложениями ${descriptionActionText} породистых ${animalText} ${breedText}. Мы предлагаем здоровых и привитых ${animalText} от проверенных заводчиков. Найдите идеального четвероногого друга для вашей семьи уже сегодня!`
    };
  }
}

function constructUrl(searchParams: { [key: string]: string | undefined }): string {
  const urlParams = new URLSearchParams();

  if (searchParams['animal-type']) {
    urlParams.set('animal-type', searchParams['animal-type']);
  }

  if (searchParams.breeds) {
    urlParams.set('breeds', searchParams.breeds);
  }

  if (searchParams['publication-type']) {
    urlParams.set('publication-type', searchParams['publication-type']);
  }

  const queryString = urlParams.toString();
  return queryString ? `/publications?${queryString}` : '/publications';
}

export { breedAndTypeMetadata, constructUrl };
export { getPublicationImageUrl } from './image.utils';
